import { Action, AnyAction, Dispatch } from "redux";
import { clearChatMessages, loadChatMessages } from "../../../../store/actions/event/chat-actions";

export const cleanup = (dispatch: Dispatch<Action | AnyAction>) => () => {
	dispatch(clearChatMessages());
};

type LoadChatMessagesEffectProps = {
	dispatch: Dispatch<Action | AnyAction>,
	sessionUuid: string | undefined,
	isPreview: boolean,
	language: string,
	singleLanguage: boolean
}
export const loadChatMessagesEffect = ({
	dispatch,
	sessionUuid,
	isPreview,
	language,
	singleLanguage
}: LoadChatMessagesEffectProps) => {
	if (sessionUuid && !isPreview) {
		dispatch(loadChatMessages(sessionUuid, singleLanguage ? 'all' : language));
	}

	return cleanup(dispatch);
};